import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import AdminSidebar from "./AdminSidebar";
import AdminTopbar from "./AdminTopbar";
import "../../assets/css/admin/adminShell.css";

const UNREAD_EVENT = "portfolio-admin-unread";

function AdminShell() {
   const location = useLocation();
   const [unreadCount, setUnreadCount] = useState(0);
   const showShell = location.pathname.startsWith("/dashboard");

   useEffect(() => {
      const onUnread = (event) => {
         const count = Number(event.detail);
         setUnreadCount(Number.isFinite(count) && count > 0 ? count : 0);
      };
      window.addEventListener(UNREAD_EVENT, onUnread);
      return () => window.removeEventListener(UNREAD_EVENT, onUnread);
   }, []);

   if (!showShell) {
      return <Outlet />;
   }

   return (
      <div className="admin-shell">
         <AdminSidebar />
         <div className="admin-shell__main">
            <AdminTopbar unreadCount={unreadCount} />
            <div className="admin-shell__content">
               <Outlet />
            </div>
         </div>
      </div>
   );
}

export default AdminShell;
